import React, { useEffect, useState } from "react";

/**
 * Live counter ticker for footer/CTA – displays 3 counters that slowly increment,
 * simulating "live" activity across FREEAYTO campaigns.
 * Numbers persist across scroll (not scroll-triggered) and tick every X seconds.
 */
const START = {
  views: 8_700_000,      // total generated views across all campaigns
  brands: 78,            // brands worked with
  campaigns: 200,        // campaigns delivered
};

const formatCompact = (n) => {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(0)}K`;
  return String(n);
};

const LiveCounterTicker = () => {
  const [values, setValues] = useState(START);

  useEffect(() => {
    const iv = setInterval(() => {
      setValues((prev) => ({
        views: prev.views + Math.floor(Math.random() * 42) + 8,
        brands: prev.brands,
        campaigns: prev.campaigns,
      }));
    }, 2400);
    return () => clearInterval(iv);
  }, []);

  const items = [
    {
      label: "Views generiert",
      value: formatCompact(values.views) + "+",
      color: "from-pink-400 via-orange-400 to-purple-400",
      live: true,
    },
    {
      label: "Brands betreut",
      value: `${values.brands}+`,
      color: "from-orange-300 via-pink-300 to-purple-300",
    },
    {
      label: "Kampagnen ausgeliefert",
      value: `${values.campaigns}+`,
      color: "from-purple-300 via-pink-300 to-orange-300",
    },
  ];

  return (
    <div
      className="relative rounded-3xl border border-white/10 bg-white/[0.03] backdrop-blur-sm p-6 md:p-8"
      data-testid="live-counter-ticker"
    >
      <div className="flex items-center gap-2 mb-6">
        <span className="relative flex h-2.5 w-2.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-pink-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-pink-500" />
        </span>
        <span className="text-[10px] uppercase tracking-[0.28em] font-bold text-neutral-400">
          Live · Seit 2020
        </span>
      </div>
      <div className="grid grid-cols-3 gap-4 md:gap-8">
        {items.map((i) => (
          <div key={i.label}>
            <div
              className={`font-display font-extrabold text-2xl md:text-4xl lg:text-5xl tracking-tight bg-gradient-to-r ${i.color} bg-clip-text text-transparent tabular-nums`}
            >
              {i.value}
            </div>
            <div className="mt-2 text-[10px] md:text-xs uppercase tracking-[0.2em] text-neutral-400 font-semibold">
              {i.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LiveCounterTicker;
